import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-modal-approval-user',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIcon,
  ],
  templateUrl: './modal-approval-user.component.html',
  styleUrl: './modal-approval-user.component.scss'
})
export class ModalApprovalUserComponent {
  
  displayedColumnsHistoric: string[] = ["username", "email"]
  dataSourceHistoric = new MatTableDataSource<any>([]);

  constructor(
    public dialogRef: MatDialogRef<ModalApprovalUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.dataSourceHistoric = this.data.approvalUserLogins ?? []
  }
}
